import { render, staticRenderFns } from "./AddPlcMonth.vue?vue&type=template&id=3556c60c&scoped=true"
import script from "./AddPlcMonth.vue?vue&type=script&lang=js"
export * from "./AddPlcMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3556c60c",
  null
  
)

export default component.exports